import firebase from 'firebase'

const config = {
  apiKey: 'AIzaSyAusy1rDYTskqnngjOynSs_uEePVqbGUWU',
  authDomain: 'fiday-4249d.firebaseapp.com',
  databaseURL: 'https://fiday-4249d.firebaseio.com',
  projectId: 'fiday-4249d',
  storageBucket: 'fiday-4249d.appspot.com',
  messagingSenderId: '287758962165',
}
firebase.initializeApp(config)

export const database = firebase.database()
export const auth = firebase.auth()
export const getAuthProvider = name => {
  switch (name) {
    case 'facebook':
      return new firebase.auth.FacebookAuthProvider()
    case 'github':
      return new firebase.auth.GithubAuthProvider()
    case 'twitter':
      return new firebase.auth.TwitterAuthProvider()
    case 'google':
    default:
      return new firebase.auth.GoogleAuthProvider()
  }
}
export default firebase



// WEBPACK FOOTER //
// ./api/firebase/firebase.js